import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { CONFIG_TOKEN, MenuConfiguration, WpMenuData, WpMenuDataItem } from './menu.type';

@Injectable()
export class MenuService {
  constructor(
    @Inject(CONFIG_TOKEN) private config: MenuConfiguration,
    protected httpClient: HttpClient) {
  }

  // public getMenus(): Observable<WpMenu> {
  //   const menu: ReplaySubject<WpMenu> = new ReplaySubject(1);
  //
  //   this.httpClient.get<WpMenu>(this.config.endpoint).subscribe(items => {
  //     if (items) {
  //       menu.next(items);
  //       menu.complete();
  //     }
  //   });
  //
  //   return menu.asObservable();
  // }

  public getMenuDataItems(slug: string | number): Observable<WpMenuData> {
    const items: ReplaySubject<WpMenuData> = new ReplaySubject(1);

    this.httpClient.get<WpMenuData>(`${this.config.endpoint}/${slug}`).subscribe(menuDataItems => {
      if (menuDataItems) {
        items.next({
          ...menuDataItems,
          items: menuDataItems.items && this.setMenuItems(menuDataItems.items),
        });
        items.complete();
      }
    });

    return items.asObservable();
  }

  private setMenuItems(items: WpMenuDataItem[]): WpMenuDataItem[] {

    return items.map((item) => {

      let url = item.url;

      if (item.type === 'post_type') {

        const urlObj = new URL(item.url);

        url = urlObj.pathname;
      }

      const itemCopy: WpMenuDataItem = {
        ...item,
        css_class: item.classes?.join(' ').trim(),
        url,
      };

      if (Array.isArray(item.child_items)) {
        itemCopy.child_items = this.setMenuItems(item.child_items);
      }

      return itemCopy;
    });
  }
}
